<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-th-large"></i> Optimiser Sheets
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="6" :url="dataURL" :filterOptions="sheetFilterOptions" :displayTools="true" :hasDateRangeFilter="true" :displayExportTools="true" exportTitle="Optimiser Sheets">
          <template v-slot:title>
            <h3>Optimiser Sheet List</h3>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkOptimiserSheet :id="row.data.id" :name="generateSheetName(row.data)" :newTab="false" />
              </td>
              <td>
                <LabelBadge :class="`label-optimiser-sheet-type-${row.data.type}`">{{formatLookupName(row.data.type, OptimiserSheetTypeLookup)}}</LabelBadge>
              </td>
              <td>
                <LabelSheetStatusBadge :status="row.data.status" />
              </td>
              <td>
                {{row.data.height}} x {{row.data.width}}
              </td>
              <td>
                {{row.data.stock.name}}
              </td>
              <td>
                {{row.data.accountLocation.name}}
              </td>
              <td>
                {{row.data.createdAt | formatDateTime}}
              </td>
              <td>
                {{row.data.dateClosed | formatDateTime | formatHyphenEmptyValue}}
              </td>
            </tr>
          </template>
        </DataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import { mapState } from "vuex"

import Utils from '@/utils/utils'
import LabelSheetStatusBadge from '@/modules/optimiser/components/labelSheetStatusBadge'

import { OptimiserSheetStatusTypes, OptimiserSheetStatusTypeLookup, OptimiserSheetTypes, OptimiserSheetTypeLookup } from '@/store/types'

export default {
  name: 'OptimiserSheetList',
  components: {
    LabelSheetStatusBadge
  },
  props: {
    filterType: String
  },
  computed: {
    ...mapState({
      accountLocations: state => state.account.accountLocations
    }),
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      return '/optimiser/sheets?' + $.param(params)
    },
    sheetFilterOptions() {
      var filterOptions = []

      filterOptions = [{
        field: 'type',
        name: 'Type',
        options: [
          { name: Utils.getLookupName(OptimiserSheetTypeLookup, OptimiserSheetTypes.standard), value: OptimiserSheetTypes.standard, class: 'label-optimiser-sheet-type-standard' },
          { name: Utils.getLookupName(OptimiserSheetTypeLookup, OptimiserSheetTypes.splitSheet), value: OptimiserSheetTypes.splitSheet, class: 'label-optimiser-sheet-type-splitSheet' }
        ]
      },
      {
        field: 'status',
        name: 'Status',
        options: [
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.open), value: OptimiserSheetStatusTypes.open, class: 'label-optimiser-sheet-status-open' },
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.processing), value: OptimiserSheetStatusTypes.processing, class: 'label-optimiser-sheet-status-processing' },
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.editing), value: OptimiserSheetStatusTypes.editing, class: 'label-optimiser-sheet-status-editing' },
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.cutting), value: OptimiserSheetStatusTypes.cutting, class: 'label-optimiser-sheet-status-cutting' },
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.completed), value: OptimiserSheetStatusTypes.completed, class: 'label-optimiser-sheet-status-completed' },
          { name: Utils.getLookupName(OptimiserSheetStatusTypeLookup, OptimiserSheetStatusTypes.cancelled), value: OptimiserSheetStatusTypes.cancelled, class: 'label-optimiser-sheet-status-cancelled' }
        ]
      }]

      filterOptions.push({
        name: 'Location',
        field: 'accountLocationId',
        columnIndex: 1,
        options: (this.accountLocations || []).filter(location => location.isActive).map(location => {
          return {
            name: location.name,
            value: location.id,
            class: 'label-misc'
          }
        })
      })

      return filterOptions
    }
  },
  created() {
    this.OptimiserSheetTypeLookup = OptimiserSheetTypeLookup
  },
  data() {
    return {
      columnList: [
        { title: "Sheet", data: "id" },
        { title: "Type", data: "type" },
        { title: "Status", data: "status" },
        { title: "Size", data: "size", sortable: false },
        { title: "Stock", data: "stock.name" },
        { title: "Location", data: "accountLocation.name" },
        { title: "Creation Date", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Completed Date", data: "dateClosed", dateFilter: true, type: 'datetime' },
      ]
    }
  },
  methods: {
    generateSheetName(sheetData) {
      return `Sheet ${sheetData.stock.code} - ${sheetData.height}x${sheetData.width}`
    }
  }
};
</script>
